import { LegalLayout } from "@/components/LegalLayout";

const Privacy = () => (
  <LegalLayout
    title="Privacy Policy"
    description="What Cash Isle collects, why, and your choices."
    updated="May 13, 2026"
  >
    <p>
      This policy explains what we collect, why, how we use it, and the choices
      you have. We follow data-minimisation: we collect what we need to run the
      Service safely and legally, and nothing else.
    </p>

    <h2>What we collect</h2>
    <ul>
      <li><strong>Account:</strong> email, phone, display name, cashtag, password hash, PIN hash.</li>
      <li><strong>Identity (KYC):</strong> legal name, date of birth, address, ID type, ID last 4 digits, when required by law.</li>
      <li><strong>Transactions:</strong> sender, receiver, amount, note, timestamps, idempotency keys.</li>
      <li><strong>Gigs:</strong> title, description, budget, location, proof media, GPS at proof submission, dispute evidence.</li>
      <li><strong>Device & security:</strong> device fingerprint, IP address, security events, login history, fraud signals.</li>
      <li><strong>Support:</strong> messages you send us.</li>
    </ul>

    <h2>How we use it</h2>
    <ul>
      <li>Provide the wallet, send/receive, gigs, escrow, disputes, and payouts.</li>
      <li>Comply with KYC, anti-money-laundering, and sanctions obligations.</li>
      <li>Detect and prevent fraud, account takeover, and abuse.</li>
      <li>Send transactional notifications (receipts, dispute updates, security alerts).</li>
      <li>Improve the Service through aggregate analytics.</li>
    </ul>

    <h2>Sharing</h2>
    <p>
      We share data with service providers acting on our behalf (cloud hosting,
      KYC verification, payout processors, fraud tools, email delivery) under
      contract. We share with regulators and law enforcement when legally
      required. We do not sell your personal data.
    </p>

    <h2>Retention</h2>
    <p>
      We keep transaction and KYC records as long as required by financial
      regulation (typically 5–7 years). Other personal data is retained only as
      long as your account is active or needed to provide the Service.
    </p>

    <h2>Your rights</h2>
    <p>
      You can request access, correction, export, or deletion of your personal
      data by emailing <a href="mailto:privacy@cashisle.app">privacy@cashisle.app</a>.
      Some data must be retained for legal reasons even after account closure.
    </p>

    <h2>Security</h2>
    <p>
      We use encryption in transit and at rest, role-based access, audit logs,
      device-binding, PIN protection, and automated fraud monitoring. No system
      is perfect — please report suspected issues to{" "}
      <a href="mailto:security@cashisle.app">security@cashisle.app</a>.
    </p>

    <h2>Children</h2>
    <p>The Service is not directed to anyone under 18.</p>

    <h2>Changes</h2>
    <p>
      Material changes will be announced in-app at least 7 days before they take
      effect.
    </p>
  </LegalLayout>
);

export default Privacy;
